/** * * Asynchronously loads the component for
AboutVLEMobile
* */ import { lazyLoad } from "utils/loadable";
export const AboutVLEMobile = lazyLoad(
  () => import("./index"),
  (module) => module.AboutVLEMobile
);
